import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { 
  FaCode, 
  FaDatabase, 
  FaMobile, 
  FaCloud, 
  FaArrowLeft,
  FaCheckCircle,
  FaTimes,
  FaCogs,
  FaChartLine,
  FaComments
} from 'react-icons/fa';
import './ServicePage.css';
import WhatsappFloat from '../components/WhatsappFloat';
import { Helmet } from 'react-helmet-async';

const DesenvolvimentoSistemas = () => {
  const navigate = useNavigate();

  // Scroll para o topo quando a página carrega
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div className="service-page">
      <Helmet>
        <title>Desenvolvimento de Sistemas | MicroCodie</title>
        <meta name="description" content="Sistemas sob medida para digitalizar, automatizar e escalar seu negócio. Soluções web, desktop, APIs e aplicativos." />
        <meta property="og:title" content="Desenvolvimento de Sistemas | MicroCodie" />
        <meta property="og:description" content="Sistemas sob medida para digitalizar, automatizar e escalar seu negócio. Soluções web, desktop, APIs e aplicativos." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.microcodie.com.br/servicos/desenvolvimento-sistemas" />
        <meta property="og:image" content="/logo192.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Desenvolvimento de Sistemas | MicroCodie" />
        <meta name="twitter:description" content="Sistemas sob medida para digitalizar, automatizar e escalar seu negócio. Soluções web, desktop, APIs e aplicativos." />
        <meta name="twitter:image" content="/logo192.png" />
        <link rel="canonical" href="https://www.microcodie.com.br/servicos/desenvolvimento-sistemas" />
      </Helmet>
      <div className="service-header">
        <div className="container">
          <motion.button 
            className="back-button"
            onClick={() => navigate('/')}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <FaArrowLeft />
            Voltar
          </motion.button>
          
          <motion.div 
            className="service-hero"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="service-icon-large">
              <FaCode />
            </div>
            <h1>Transforme sua ideia em um sistema poderoso</h1>
            <p className="service-subtitle">
              Desenvolvemos sistemas sob medida que resolvem de verdade os problemas da sua empresa ou do seu mercado
            </p>
            <button 
              className="btn btn-primary hero-cta"
              onClick={() => navigate('/#contato')}
            >
              Fale com a gente
            </button>
          </motion.div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          {/* Seção: Por que criar um sistema sob medida? */}
          <motion.div 
            className="why-custom-section"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2>Por que criar um sistema sob medida?</h2>
            
            <div className="problems-benefits-grid">
              <div className="problems-section">
                <h3>Problemas com soluções prontas</h3>
                <div className="problems-list">
                  <div className="problem-item">
                    <FaTimes className="problem-icon" />
                    <div>
                      <h4>Engessadas</h4>
                      <p>Funcionalidades limitadas que não atendem suas necessidades específicas</p>
                    </div>
                  </div>
                  <div className="problem-item">
                    <FaTimes className="problem-icon" />
                    <div>
                      <h4>Caras</h4>
                      <p>Licenças mensais/anuais que acumulam custos a longo prazo</p>
                    </div>
                  </div>
                  <div className="problem-item">
                    <FaTimes className="problem-icon" />
                    <div>
                      <h4>Ineficientes</h4>
                      <p>Processos que não se adaptam ao seu fluxo de trabalho</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="benefits-section">
                <h3>Benefícios de algo feito sob medida</h3>
                <div className="benefits-list">
                  <div className="benefit-item">
                    <FaCheckCircle className="benefit-icon" />
                    <div>
                      <h4>Escala</h4>
                      <p>Cresce junto com seu negócio, sem limitações</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <FaCheckCircle className="benefit-icon" />
                    <div>
                      <h4>Flexibilidade</h4>
                      <p>Adapta-se às suas necessidades e processos únicos</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <FaCheckCircle className="benefit-icon" />
                    <div>
                      <h4>Controle</h4>
                      <p>Você tem total controle sobre funcionalidades e dados</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <FaCheckCircle className="benefit-icon" />
                    <div>
                      <h4>Inovação</h4>
                      <p>Diferencial competitivo com funcionalidades exclusivas</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Seção: Tem uma ideia? A gente pode te ajudar */}
          <motion.div 
            className="idea-help-section"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h2>Tem uma ideia? A gente pode te ajudar</h2>
            <div className="idea-content">
              <div className="idea-text">
                <p>
                  Mesmo que você ainda esteja validando sua ideia ou não tenha todos os recursos no momento, 
                  entre em contato. Adoramos bons desafios e podemos ajudar você a transformar sua visão 
                  em realidade, mesmo com orçamentos limitados.
                </p>
                <p>
                  Acreditamos que grandes ideias não devem ser limitadas por recursos iniciais. 
                  Trabalhamos com diferentes modelos de parceria e podemos encontrar a melhor forma 
                  de viabilizar seu projeto.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Seção: Tipos de sistemas que desenvolvemos */}
          <motion.div 
            className="systems-types-section"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h2>Tipos de sistemas que desenvolvemos</h2>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <div className="systems-grid">
                <div className="system-card">
                  <FaCode className="system-icon" />
                  <h3>Web Apps</h3>
                  <p>Aplicações web modernas e responsivas para qualquer dispositivo</p>
                </div>
                <div className="system-card">
                  <FaCogs className="system-icon" />
                  <h3>Sistemas de Gestão</h3>
                  <p>ERPs, CRMs e sistemas administrativos completos</p>
                </div>
                <div className="system-card">
                  <FaCloud className="system-icon" />
                  <h3>Plataformas SaaS</h3>
                  <p>Software como serviço escalável e multi-tenant</p>
                </div>
                <div className="system-card">
                  <FaDatabase className="system-icon" />
                  <h3>Integrações</h3>
                  <p>APIs e integrações entre diferentes sistemas</p>
                </div>
                <div className="system-card">
                  <FaMobile className="system-icon" />
                  <h3>Apps Mobile</h3>
                  <p>Aplicações nativas e híbridas para iOS e Android</p>
                </div>
                <div className="system-card">
                  <FaChartLine className="system-icon" />
                  <h3>Sistemas de Analytics</h3>
                  <p>Dashboards e relatórios para tomada de decisão</p>
                </div>
                <div className="system-card">
                  <FaComments className="system-icon" />
                  <h3>Outros</h3>
                  <p>Soluções personalizadas para necessidades específicas do seu negócio</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Seção: Processo de trabalho */}
          <motion.div 
            className="work-process-section"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            <h2>Processo de trabalho</h2>
            <div className="process-timeline">
              <div className="process-step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Diagnóstico</h3>
                  <p>Análise profunda das necessidades e objetivos do projeto</p>
                </div>
              </div>
              <div className="process-step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Proposta</h3>
                  <p>Proposta detalhada com escopo, cronograma e investimento</p>
                </div>
              </div>
              <div className="process-step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Prototipação</h3>
                  <p>Criação de protótipos para validação do conceito</p>
                </div>
              </div>
              <div className="process-step">
                <div className="step-number">4</div>
                <div className="step-content">
                  <h3>Desenvolvimento Ágil</h3>
                  <p>Desenvolvimento iterativo com entregas contínuas</p>
                </div>
              </div>
              <div className="process-step">
                <div className="step-number">5</div>
                <div className="step-content">
                  <h3>Entrega e Suporte</h3>
                  <p>Deploy em produção e suporte contínuo</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Seção: Depoimentos */}
          {/* <motion.div 
            className="testimonials-section"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <h2>Casos de sucesso</h2>
            <div className="testimonials-grid">
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>
                    "A MicroCodie transformou nossa ideia em um sistema completo que revolucionou 
                    nossa operação. O resultado superou todas as expectativas."
                  </p>
                </div>
                <div className="testimonial-author">
                  <h4>João Silva</h4>
                  <span>CEO - TechStart</span>
                </div>
              </div>
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>
                    "Profissionalismo e qualidade excepcionais. O sistema desenvolvido nos deu 
                    um diferencial competitivo no mercado."
                  </p>
                </div>
                <div className="testimonial-author">
                  <h4>Maria Santos</h4>
                  <span>Diretora - InovaçãoCorp</span>
                </div>
              </div>
            </div>
          </motion.div> */}

          {/* Seção: CTA Final */}
          <motion.div 
            className="final-cta-section"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }}
          >
            <h2>Tem uma ideia? Vamos conversar</h2>
            <p>
              Não deixe sua ideia apenas no papel. Entre em contato conosco e vamos transformar 
              sua visão em um sistema poderoso que impulsiona seu negócio.
            </p>
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/#contato')}
            >
              Fale com a gente
            </button>
          </motion.div>
        </div>
      </div>
      <WhatsappFloat />
    </div>
  );
};

export default DesenvolvimentoSistemas; 